export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="-5.0 -10.0 110.0 135.0"
    >
      <g>
        <path d="m27 36.75-1.5-1.75-15.5 14 15.5 14.25 1.5-2-12-11h29.75v-2.5h-29.75z" />
        <path d="m38 56.25h-2.5v21.25h9.25v-2.5h-6.75z" />
        <path d="m35.5 17.5v23.75h2.5v-21.25h37.25l-24.75 7.75v60l30-9.5v-60.75zm42.5 59-25 8v-55l25-8z" />
      </g>
    </svg>
  );
};
